import { render } from "./Background.vue?vue&type=template&id=c82687f6&scoped=true&ts=true"
import script from "./Background.vue?vue&type=script&lang=ts"
export * from "./Background.vue?vue&type=script&lang=ts"

import "./Background.vue?vue&type=style&index=0&id=c82687f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.5.5__webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82687f6"]])

export default __exports__